'use client'

import { cardDrawStore } from '@/store/card-draw.store'
import dynamic from 'next/dynamic'
import React from 'react'

const HosooDrawMotion = dynamic(() => import('@/components/draw-motion/hosoo/HosooDrawMotion'), {
  ssr: false,
  loading: () => null,
})

const LoopyDrawMotion = dynamic(() => import('@/components/draw-motion/loopy/LoopyDrawMotion'), {
  ssr: false,
  loading: () => null,
})

const SaryeonghwaDrawMotion = dynamic(() => import('@/components/draw-motion/saryeonghwa/LoopyDrawMotion'), {
  ssr: false,
  loading: () => null,
})

export const DrawMotion = () => {
  const { motionPageVisible, drawArtistType } = cardDrawStore()

  return (
    <div
      className="fixed top-0 left-0 w-full h-full z-50 pc:w-[512px] pc:left-1/2 pc:transform pc:-translate-x-1/2"
      style={{ display: motionPageVisible ? 'block' : 'none' }}
    >
      {drawArtistType === 'hosoo' && <HosooDrawMotion />}
      {drawArtistType === 'loopy' && <LoopyDrawMotion />}
      {drawArtistType === 'saryeonghwa' && <SaryeonghwaDrawMotion />}
    </div>
  )
}
